export const FILE_TYPES = Object.freeze({
  COLLECTIVE_BARGAINING_CONTRACTS: 6,
  ANNUAL_SURVEYS: 7,
  COMPLAINTS: 8,
  ADMISSION_AND_PAYMENT_BAN_CORRESPONDENCE: 17,
  BENEFIT_PLANS: 21,
  EMPLOYEE_HANDBOOK: 24,
  MANAGED_CARE_VA_INSURANCE_CONTRACT: 40,
  MEDICAL_DIRECTOR_LICENSE: 58,
  MEDICAL_DIRECTOR_CONTRACT: 59,
  SELLER_MEDICARE_NUMBER: 63,
  BUYER_EIN_NUMBER: 65,
  BUYER_NPI_NUMBER: 66,
  DIETARY_STAFFING_SCHEDULE: 75,
  FOOD_COMMITTEE_MEETINGS: 76,
  COPY_OF_MENUS: 77,
  CORPORATE_COMPLIANCE: 79,
  NURSING_STAFFING_SCHEDULE: 80,
  HOUSEKEEPING_STAFFING_SCHEDULE: 81,
  LAUNDRY_STAFFING_SCHEDULE: 82,
  MAIN_FOOD_SUPPLIER_INVOICE: 83,
  MAIN_FOOD_SUPPLIER_CONTRACT: 84,
  SECONDARY_FOOD_SUPPLIER_INVOICE: 85,
  SECONDARY_FOOD_SUPPLIER_CONTRACT: 86,
  DAIRY_PROVIDER_INVOICE: 87,
  DAIRY_PROVIDER_CONTRACT: 88,
  BAKERY_PROVIDER_INVOICE: 89,
  BAKERY_PROVIDER_CONTRACT: 90,
  CHEMICAL_PROVIDER_INVOICE: 91,
  CHEMICAL_PROVIDER_CONTRACT: 92,
  PAPER_PLASTIC_VENDOR_INVOICE: 93,
  PAPER_PLASTIC_VENDOR_CONTRACT: 94,
  COFFEE_VENDOR_INVOICE: 95,
  COFFEE_VENDOR_CONTRACT: 96,
  CORPORATE_COMPLIANCE_VENDOR_CONTRACT: 97,
  DISH_MACHINE_FINANCE_AGREEMENT: 98,
  DISH_MACHINE_LEASE_AGREEMENT: 99,
  DISH_MACHINE_RENTAL_CONTRACT: 100,
  CORPORATE_COMPLIANCE_VENDOR_INVOICE: 101,
  MEDICARE_A_CERTIFICATION: 102,
  EMR_SOFTWARE_VENDOR_INVOICE: 103,
  EMR_SOFTWARE_VENDOR_CONTRACT: 104,
  REHAB_VENDOR_INVOICE: 105,
  REHAB_VENDOR_CONTRACT: 106,
  FLOOR_PLANS: 108,
  TWELVE_MONTH_LOOKBACK: 110,
  W9: 111,
  HOSPICE_AGENCY_CONTRACT: 113,
  PHONE_SERVICE_PROVIDER_INVOICE: 116,
  PHONE_SERVICE_PROVIDER_CONTRACT: 117,
  PHONE_EQUIPMENT_PROVIDER_INVOICE: 118,
  PHONE_EQUIPMENT_PROVIDER_CONTRACT: 119,
  INTERNET_SERVICE_PROVIDER_INVOICE: 120,
  INTERNET_SERVICE_PROVIDER_CONTRACT: 121,
  TV_AND_CABLE_PROVIDER_INVOICE: 122,
  TV_AND_CABLE_PROVIDER_CONTRACT: 123,
  CHANNEL_LINEUP: 124,
  IT_PROVIDER_INVOICE: 125,
  IT_PROVIDER_CONTRACT: 126,
  REFERRAL_SOFTWARE: 127,
  STAFFING_AGENCY_VENDOR_INVOICE: 128,
  STAFFING_AGENCY_VENDOR_CONTRACT: 129,
  DME_SUPPLY_VENDOR_INVOICE: 130,
  DME_SUPPLY_VENDOR_CONTRACT: 131,
  MEDICAL_DIRECTOR_VENDOR_INVOICE: 132,
  MEDICAL_DIRECTOR_VENDOR_CONTRACT: 133,
  MEDICAL_SUPPLIES_VENDOR_INVOICE: 134,
  MEDICAL_SUPPLIES_VENDOR_CONTRACT: 135,
  PHARMACY_VENDOR_INVOICE: 136,
  PHARMACY_VENDOR_CONTRACT: 137,
  PHARMACY_CONSULTANT_VENDOR_INVOICE: 138,
  PHARMACY_CONSULTANT_VENDOR_CONTRACT: 139,
  LAB_COVID_TEST_VENDOR_INVOICE: 140,
  LAB_COVID_TEST_VENDOR_CONTRACT: 141,
  LABS_VENDOR_INVOICE: 142,
  LABS_VENDOR_CONTRACT: 143,
  XRAY_VENDOR_INVOICE: 144,
  XRAY_VENDOR_CONTRACT: 145,
  DME_RENTAL_VENDOR_INVOICE: 146,
  DME_RENTAL_VENDOR_CONTRACT: 147,
  WHEELCHAIR_TRANSPORT_VENDOR_INVOICE: 148,
  WHEELCHAIR_TRANSPORT_VENDOR_CONTRACT: 149,
  STRETCHER_TRANSPORT_VENDOR_INVOICE: 150,
  STRETCHER_TRANSPORT_VENDOR_CONTRACT: 151,
  MEDICAL_WASTE_VENDOR_INVOICE: 152,
  MEDICAL_WASTE_VENDOR_CONTRACT: 153,
  OXYGEN_PROVIDER_INVOICE: 154,
  OXYGEN_PROVIDER_CONTRACT: 155,
  OXYGEN_RENTAL_PROVIDER_INVOICE: 156,
  OXYGEN_RENTAL_PROVIDER_CONTRACT: 157,
  ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR_INVOICE: 158,
  ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR_CONTRACT: 159,
  WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR_INVOICE: 160,
  WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR_CONTRACT: 161,
  WOUND_PHYSICIAN_NURSE_VENDOR_INVOICE: 162,
  WOUND_PHYSICIAN_NURSE_VENDOR_CONTRACT: 163,
  PICC_MIDLINE_INSERTION_VENDOR_INVOICE: 164,
  PICC_MIDLINE_INSERTION_VENDOR_CONTRACT: 165,
  EQUIPMENT_LEASE_VENDOR_INVOICE: 166,
  EQUIPMENT_LEASE_VENDOR_CONTRACT: 167,
  EQUIPMENT_RENTALS_VENDOR_INVOICE: 168,
  EQUIPMENT_RENTALS_VENDOR_CONTRACT: 169,
  THERAPY_OUTSOURCED_COMPANY_INVOICE: 170,
  THERAPY_OUTSOURCED_COMPANY_CONTRACT: 171,
  THERAPY_STAFFING_AGENCY_INVOICE: 172,
  THERAPY_STAFFING_AGENCY_CONTRACT: 173,
  THERAPY_SUPPLIES_PROVIDER_INVOICE: 174,
  THERAPY_SUPPLIES_PROVIDER_CONTRACT: 175,
  THERAPY_SOFTWARE_VENDOR_INVOICE: 176,
  THERAPY_SOFTWARE_VENDOR_CONTRACT: 177,
  THERAPY_MANAGEMENT_COMPANY_INVOICE: 178,
  THERAPY_MANAGEMENT_COMPANY_CONTRACT: 179,
  DIETARY_OUTSOURCED_COMPANY_INVOICE: 180,
  DIETARY_OUTSOURCED_COMPANY_CONTRACT: 181,
  BREAD_VENDOR_INVOICE: 182,
  BREAD_VENDOR_CONTRACT: 183,
  JUICE_VENDOR_INVOICE: 184,
  JUICE_VENDOR_CONTRACT: 185,
  DIETARY_STAFFING_VENDOR_INVOICE: 186,
  DIETARY_STAFFING_VENDOR_CONTRACT: 187,
  OUTSOURCED_DIETICIAN_VENDOR_INVOICE: 188,
  OUTSOURCED_DIETICIAN_VENDOR_CONTRACT: 189,
  DIETARY_EQUIPMENT_RENTAL_VENDOR_INVOICE: 190,
  DIETARY_EQUIPMENT_RENTAL_VENDOR_CONTRACT: 191,
  DIETARY_SUPPLIES_VENDOR_INVOICE: 192,
  DIETARY_SUPPLIES_VENDOR_CONTRACT: 193,
  MENU_TICKET_SYSTEM_VENDOR_INVOICE: 194,
  MENU_TICKET_SYSTEM_VENDOR_CONTRACT: 195,
  HOUSEKEEPING_SUPPLIES_VENDOR_INVOICE: 196,
  HOUSEKEEPING_SUPPLIES_VENDOR_CONTRACT: 197,
  HOUSEKEEPING_CHEMICALS_VENDOR_INVOICE: 198,
  HOUSEKEEPING_CHEMICALS_VENDOR_CONTRACT: 199,
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_INVOICE: 200,
  HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_CONTRACT: 201,
  LINEN_SUPPLIER_VENDOR_INVOICE: 202,
  LINEN_SUPPLIER_VENDOR_CONTRACT: 203,
  HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR_INVOICE: 204,
  HOUSEKEEPING_EQUIPMENT_RENTAL_VENDOR_CONTRACT: 205,
  MAINTENANCE_SOFTWARE_VENDOR_INVOICE: 206,
  MAINTENANCE_SOFTWARE_VENDOR_CONTRACT: 207,
  MAINTENANCE_SERVICE_PROVIDER_INVOICE: 208,
  MAINTENANCE_SERVICE_PROVIDER_CONTRACT: 209,
  ELEVATOR_SERVICE_COMPANY_INVOICE: 210,
  ELEVATOR_SERVICE_COMPANY_CONTRACT: 211,
  MAINTENANCE_SUPPLIES_VENDOR_INVOICE: 212,
  MAINTENANCE_SUPPLIES_VENDOR_CONTRACT: 213,
  FIRE_SAFETY_VENDOR_INVOICE: 214,
  FIRE_SAFETY_VENDOR_CONTRACT: 215,
  SECURITY_SYSTEM_VENDOR_INVOICE: 216,
  SECURITY_SYSTEM_VENDOR_CONTRACT: 217,
  ELECTRIC_UTILITY_VENDOR_INVOICE: 218,
  ELECTRIC_UTILITY_VENDOR_CONTRACT: 219,
  GAS_UTILITY_VENDOR_INVOICE: 220,
  GAS_UTILITY_VENDOR_CONTRACT: 221,
  WATER_AND_SEWER_UTILITY_VENDOR_INVOICE: 222,
  WATER_AND_SEWER_UTILITY_VENDOR_CONTRACT: 223,
  WASTE_HAULING_VENDOR_INVOICE: 224,
  WASTE_HAULING_VENDOR_CONTRACT: 225,
  MAINTENANCE_EQUIPMENT_RENTAL_VENDOR_INVOICE: 226,
  MAINTENANCE_EQUIPMENT_RENTAL_VENDOR_CONTRACT: 227,
  PEST_CONTROL_VENDOR_INVOICE: 228,
  PEST_CONTROL_VENDOR_CONTRACT: 229,
  GENERATOR_SERVICE_COMPANY_INVOICE: 230,
  GENERATOR_SERVICE_COMPANY_CONTRACT: 231,
  LANDSCAPING_VENDOR_INVOICE: 232,
  LANDSCAPING_VENDOR_CONTRACT: 233,
  HOOD_VENT_CLEANING_VENDOR_INVOICE: 234,
  HOOD_VENT_CLEANING_VENDOR_CONTRACT: 235,
  GREASE_TRAP_CLEANING_PROVIDER_INVOICE: 236,
  GREASE_TRAP_CLEANING_PROVIDER_CONTRACT: 237,
  WATER_SOFTENING_VENDOR_INVOICE: 238,
  WATER_SOFTENING_VENDOR_CONTRACT: 239,
  COPIER_MACHINE_SERVICE_COMPANY_INVOICE: 240,
  COPIER_MACHINE_SERVICE_COMPANY_CONTRACT: 241,
  COPIER_MACHINE_LEASE_COMPANY_INVOICE: 242,
  COPIER_MACHINE_LEASE_COMPANY_CONTRACT: 243,
  MEDICAL_FORMS_VENDOR_INVOICE: 244,
  MEDICAL_FORMS_VENDOR_CONTRACT: 245,
  BACKUP_INTERNET_PROVIDER_INVOICE: 246,
  BACKUP_INTERNET_PROVIDER_CONTRACT: 247,
  PHONE_PROVIDER_INVOICE: 248,
  PHONE_PROVIDER_CONTRACT: 249,
  SHREDDING_COMPANY_INVOICE: 250,
  SHREDDING_COMPANY_CONTRACT: 251,
  DOCU_STORAGE_COMPANY_INVOICE: 252,
  DOCU_STORAGE_COMPANY_CONTRACT: 253,
  EFAX_VENDOR_INVOICE: 254,
  EFAX_VENDOR_CONTRACT: 255,
  BACKGROUND_CHECKS_VENDOR_INVOICE: 256,
  BACKGROUND_CHECKS_VENDOR_CONTRACT: 257,
  OFFICE_SUPPLIES_VENDOR_INVOICE: 258,
  OFFICE_SUPPLIES_VENDOR_CONTRACT: 259,
  MARKETING_SUPPLIES_VENDOR_INVOICE: 260,
  MARKETING_SUPPLIES_VENDOR_CONTRACT: 261,
  PURCHASING_SOFTWARE_VENDOR_INVOICE: 262,
  PURCHASING_SOFTWARE_VENDOR_CONTRACT: 263,
  ACCOUNTANT_VENDOR_INVOICE: 264,
  ACCOUNTANT_VENDOR_CONTRACT: 265,
  AP_SOFTWARE_VENDOR_INVOICE: 266,
  AP_SOFTWARE_VENDOR_CONTRACT: 267,
  RFMS_SOFTWARE_VENDOR_INVOICE: 268,
  RFMS_SOFTWARE_VENDOR_CONTRACT: 269,
  MAIL_AND_POSTAGE_VENDOR_INVOICE: 270,
  MAIL_AND_POSTAGE_VENDOR_CONTRACT: 271,
  HMO_CONTRACT_NEGOTIATION_PROVIDER_INVOICE: 272,
  HMO_CONTRACT_NEGOTIATION_PROVIDER_CONTRACT: 273,
  UNEMPLOYMENT_LAWYER_VENDOR_INVOICE: 274,
  UNEMPLOYMENT_LAWYER_VENDOR_CONTRACT: 275,
  TIME_AND_ATTENDANCE_SOFTWARE_VENDOR_INVOICE: 276,
  TIME_AND_ATTENDANCE_SOFTWARE_VENDOR_CONTRACT: 277,
  WOUND_VAC_VENDOR_INVOICE: 278,
  WOUND_VAC_VENDOR_CONTRACT: 279,
  AUDIT_VENDOR_INVOICE: 280,
  AUDIT_VENDOR_CONTRACT: 281,
  ACTIVITY_SUPPLIES_VENDOR_INVOICE: 282,
  ACTIVITY_SUPPLIES_VENDOR_CONTRACT: 283,
  MDS_SCRUBBER_VENDOR_INVOICE: 284,
  MDS_SCRUBBER_VENDOR_CONTRACT: 285,
  INSURANCE_VERIFICATION_SOFTWARE_VENDOR_INVOICE: 286,
  INSURANCE_VERIFICATION_SOFTWARE_VENDOR_CONTRACT: 287,
  PAYROLL_VENDOR_INVOICE: 288,
  PAYROLL_VENDOR_CONTRACT: 289,
  VISITOR_SCREENING_VENDOR_INVOICE: 290,
  VISITOR_SCREENING_VENDOR_CONTRACT: 291,
  POLICY_AND_PROCEDURE_VENDOR_INVOICE: 292,
  POLICY_AND_PROCEDURE_VENDOR_CONTRACT: 293,
  PHONE_ON_HOLD_VENDOR_INVOICE: 294,
  PHONE_ON_HOLD_VENDOR_CONTRACT: 295,
  VENDING_MACHINE_SERVICES_VENDOR_INVOICE: 296,
  VENDING_MACHINE_SERVICES_VENDOR_CONTRACT: 297,
  FACILITY_VAN_VENDOR_INVOICE: 298,
  FACILITY_VAN_VENDOR_CONTRACT: 299,
  PROMO_ITEMS_VENDOR_INVOICE: 300,
  PROMO_ITEMS_VENDOR_CONTRACT: 301,
  MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR_INVOICE: 302,
  MEDICAL_EQUIPMENT_PM_SERVICES_VENDOR_CONTRACT: 303,
  RECRUITMENT_ONBOARDING_VENDOR_INVOICE: 304,
  RECRUITMENT_ONBOARDING_VENDOR_CONTRACT: 305,
  EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR_INVOICE: 306,
  EMPLOYEE_SCHEDULING_SOFTWARE_VENDOR_CONTRACT: 307,
  REFERRAL_SOFTWARE_VENDOR_INVOICE: 308,
  REFERRAL_SOFTWARE_VENDOR_CONTRACT: 309,
  TRANSPORTATION_VENDOR_INVOICE: 310,
  TRANSPORTATION_VENDOR_CONTRACT: 311,
  EMERGENCY_ICE_VENDOR_INVOICE: 312,
  EMERGENCY_ICE_VENDOR_CONTRACT: 313,
  EMERGENCY_WATER_VENDOR_INVOICE: 314,
  EMERGENCY_WATER_VENDOR_CONTRACT: 315,
  PETROLEUM_PROVIDER_INVOICE: 316,
  PETROLEUM_PROVIDER_CONTRACT: 317,
  RECIPROCAL_TRANSFER_AGREEMENT_VENDOR_INVOICE: 318,
  RECIPROCAL_TRANSFER_AGREEMENT_VENDOR_CONTRACT: 319,
  REFRIGERATED_TRUCK_VENDOR_INVOICE: 320,
  REFRIGERATED_TRUCK_VENDOR_CONTRACT: 321,
  HOSPICE_VENDOR_INVOICE: 322,
  HOSPICE_VENDOR_CONTRACT: 323,
  PODIATRY_VENDOR_INVOICE: 324,
  PODIATRY_VENDOR_CONTRACT: 325,
  DENTAL_VENDOR_INVOICE: 326,
  DENTAL_VENDOR_CONTRACT: 327,
  BEAUTY_AND_BARBER_VENDOR_INVOICE: 328,
  BEAUTY_AND_BARBER_VENDOR_CONTRACT: 329,
  EYE_DOCTOR_VENDOR_INVOICE: 330,
  EYE_DOCTOR_VENDOR_CONTRACT: 331,
  EDUCATION_VENDOR_INVOICE: 332,
  EDUCATION_VENDOR_CONTRACT: 333,
  CURRENT_MENU_SYSTEM_CONTRACT: 334,
  PLANT_OPERATIONS_PHASE_ONE_REPORTS: 335,
  PLANT_OPERATIONS_PHASE_TWO_REPORTS: 336,
  EMPLOYEE_PAYROLL_FORM: 337,
  TIME_CARD_REPORT: 338,
  PAYROLL_REPORT: 339,
  PAY_RULES_FINAL_BALANCE: 340,
  CBA: 341,
  HOUSEKEEPING_EQUIPMENT_PICTURE: 342,
  VEHICLE_INSURANCE: 343,
  VEHILCE_REGISTRATION: 344,
  DRIVER_LICENSE: 345,
  CLEAN_DRIVING_RECORD: 346,
  CLINICAL_INFECTION_CONTROL_POLICIES: 347,
  CLIA_WAIVER: 348,
  LAB_PERMITS: 349,
  QAPI: 350,
  FACILITY_ASSESSMENT: 351,
  PHYSICIAN_CONTRACT: 352,
});
